import { PropsWithChildren, useEffect, useState } from 'react';
import './main-content.component.scss';
import { useLocation } from 'react-router-dom';
interface MainContainerProps extends PropsWithChildren {
  fullHeight?: boolean;
}
const MainContainerComponent = ({
  children,
  fullHeight,
}: MainContainerProps) => {
  const [className, setClassName] = useState('header-height');

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the pathname changes
  }, [pathname]);

  useEffect(() => {
    if (fullHeight) {
      setClassName('main-full-height');
    } else {
      setClassName('header-height');
    }
  }, [fullHeight]);
  return <div className={`main-content ${className}`}>{children}</div>;
};

export default MainContainerComponent;
